import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTopButton from "./javascript/ScrollTopTopButoon";
import { Navbar } from "./components/header/header";
import { Footer } from "./components/footer/footer";
import { Analytics } from "@vercel/analytics/react";
import Home from "./pages/home/home"; // ✅ Import other pages the same way
import Contact from "./pages/contact/contact";
import Over from "./pages/over/over";
import Kunstgalerie from "./pages/kunstgalerie/kunstgalerie";
import Workshops from "./pages/workshops/workshops";
import FAQ from "./pages/faq/faq";

function App() {
  return (
    <div className="app-wrapper">
      <Router>
        <Navbar />
        <div className="app-content">
          <ScrollToTopButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/over" element={<Over />} />
            <Route path="/kunstgalerie" element={<Kunstgalerie />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </div>
        <Footer />
      </Router>
      <Analytics />
    </div>
  );
}

export default App;
